import { useEffect } from 'react';
import { Tweet } from 'react-tweet';
import { SocialMediaCardStyled } from './style-component';

const extractTweetId = (url: string) => {
  const regex = /status\/(\d+)(?:\?|$)/;
  const matches = url.match(regex);
  return matches ? matches[1] : null;
};


const CardXTwitter = ({ url, style }: { url: string, style: React.CSSProperties }) => {
  const tweetId = extractTweetId(url);
  if (!tweetId) return null;

  return (
    <div style={{ width: '100%', maxWidth: '372px', margin: '0 auto', overflow: 'hidden', borderRadius: '16px', ...style }}>
      <Tweet id={tweetId} />
    </div>
  );
};

const CardFacebook = ({ url, style }: { url: string, style: React.CSSProperties }) => {
  try {
    useEffect(() => {
      if (window.FB) {
        window.FB.XFBML.parse();
      }
    }, []);
    return (
      <SocialMediaCardStyled style={style}>
        <div
          data-testid="facebook-post"
          className="fb-post"
          data-href={url}
          data-width="350"
          data-show-text="true"
        >
          <blockquote
            cite={url}
            className="fb-xfbml-parse-ignore"
          />
        </div>
      </SocialMediaCardStyled>
    );
  } catch (e) {
    console.error(e)
    return null;
  }
};


const COMPONENT = {
  'FACEBOOK': CardFacebook,
  'TWITTER': CardXTwitter,
  'XTWITTER': CardXTwitter
} as const;

const SocialMediaCard = ({ url, socialMediaName, style }: { url: string; socialMediaName: string, style?: React.CSSProperties }) => {
  const Wrapper = COMPONENT[socialMediaName?.toUpperCase() as keyof typeof COMPONENT] ?? null;
  return Wrapper ? <Wrapper url={url} style={style ?? {}} /> : null;
};

export default SocialMediaCard;
